// Environment variables as fallback
const envConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  clientId: process.env.REACT_APP_CLIENT_ID,
  issuer: process.env.REACT_APP_ISSUER,
  scope: process.env.REACT_APP_SCOPE,
  idp: process.env.REACT_APP_IDP,
  idpDomain: process.env.REACT_APP_IDP_DOMAIN,
}

const appConfig = { ...envConfig }

export const getConfig = async () => {
  try {
    const response = await fetch('/appConfig.json')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const jsonConfig = await response.json()
    
    // Return merged config (JSON values override env vars)
    Object.assign(appConfig, jsonConfig)
    return jsonConfig
  } catch (error) {
    console.warn('Failed to load app config from /appConfig.json, using environment variables:', error.message)
    return envConfig
  }
}

export default appConfig

